import { Table } from 'react-bootstrap'
import { getCountryRiskColor } from '../../helpers/stammdaten.helper'
import { t } from '../../locale'
import { Client, UserAccess } from '../../react-app-env'
import ClientActionButtons from './ClientActionButtons'

interface ClientTableViewProps {
  clients: Client[]
  allClients: Client[]
  selectedClients: Client[]
  userAccess: UserAccess
  clientStatusParam: string | null
  countryRisks: Record<string, number | null>
  countryNames: Record<string, string>
  notedClientIds: Set<string>
  kycCheckEnabled: boolean
  amlSearchEnabled: boolean
  onCheckboxChange: (client: Client) => void
  onSelectAll: (clients: Client[]) => void
  onCheck: (client: Client) => void
  onAmlCheck: (client: Client) => void
  onView: (client: Client) => void
  onSurveyForm: (clientId: string, isPerson: number) => void
  onDeactivate: (client: Client) => void
  onDelete: (clientNumber: number, clientId: string) => void
  onRiskChange: (clientId: string, risik: string) => void
}

function ClientTableView({
  clients,
  allClients,
  selectedClients,
  userAccess,
  clientStatusParam,
  countryRisks,
  countryNames,
  notedClientIds,
  kycCheckEnabled,
  amlSearchEnabled,
  onCheckboxChange,
  onSelectAll,
  onCheck,
  onAmlCheck,
  onView,
  onSurveyForm,
  onDeactivate,
  onDelete,
  onRiskChange,
}: ClientTableViewProps) {
  return (
    <div className='table-responsive'>
      <Table className='table-striped'>
        <thead>
          <tr className='table-light small'>
            <th className='text-center px-1'>
              <input
                type='checkbox'
                onChange={e => {
                  onSelectAll(e.target.checked ? allClients : [])
                }}
              />
            </th>
            <th scope='col'>{t('clientNumber')}</th>
            <th scope='col'>{t('isPerson')}</th>
            <th scope='col'>{t('name')}</th>
            <th scope='col'>{t('firstName')}</th>
            <th scope='col'>{t('lastCheck')}</th>
            <th scope='col'>{t('numberChecks')}</th>
            <th scope='col'>{t('dateOfBirth')}</th>
            <th scope='col' style={{ minWidth: '200px' }}>
              {t('country')}
            </th>
            <th scope='col'>{t('risik')}</th>
            <th></th>
          </tr>
        </thead>
        <tbody className='small'>
          {clients.map((client, index) => (
            <tr key={client._id} id={client._id}>
              <td className='text-center'>
                <input
                  type='checkbox'
                  checked={selectedClients.some(selected => selected._id === client._id)}
                  onChange={() => onCheckboxChange(client)}
                />
              </td>
              <td>{client.clientNumber}</td>
              <td>{client.isPerson === 1 ? t('yes') : t('no')}</td>
              <td>{client.name}</td>
              <td>{client.firstName}</td>
              <td>
                <span
                  className={`last-check rounded ${client.lastCheck ? (client.risk ? 'border border-danger text-danger' : 'border border-success text-success') : ''}`}
                >
                  {client.lastCheck || '\u00A0'}
                </span>
              </td>
              <td>{client.numberChecks}</td>
              <td>{client.dateOfBirth}</td>
              <td className='text-left' style={{ minWidth: '200px' }}>
                <span className={`${getCountryRiskColor(client.country, countryRisks)}`}>
                  {countryNames[client.country] || client.country}
                </span>
              </td>
              <td>
                <select
                  className={`form-select form-select-sm ${
                    client.risik === 'high'
                      ? 'border border-danger'
                      : client.risik === 'medium'
                        ? 'border border-warning'
                        : client.risik === 'low'
                          ? 'border border-success'
                          : 'border border-secondary'
                  }`}
                  style={{ minWidth: '100px' }}
                  value={client.risik || 'unknown'}
                  onChange={e => onRiskChange(String(client._id), e.target.value)}
                >
                  <option value='unknown'>-- </option>
                  <option value='low'>{t('risikLow')}</option>
                  <option value='medium'>{t('risikMedium')}</option>
                  <option value='high'>{t('risikHigh')}</option>
                </select>
              </td>
              <td>
                <ClientActionButtons
                  client={client}
                  userAccess={userAccess}
                  clientStatusParam={clientStatusParam}
                  hasNotes={notedClientIds.has(client._id)}
                  layout='table'
                  openDropdownUp={index === clients.length - 1}
                  kycCheckEnabled={kycCheckEnabled}
                  amlSearchEnabled={amlSearchEnabled}
                  onCheck={onCheck}
                  onAmlCheck={onAmlCheck}
                  onView={onView}
                  onSurveyForm={onSurveyForm}
                  onDeactivate={onDeactivate}
                  onDelete={onDelete}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}

export default ClientTableView
